import { httpClient, HttpMethod } from './http-client';
import { StructureType, StructureTypeResponse } from '../@types';

export const getStructureTypesByCategoryCode = (categoryCode: string): Promise<StructureTypeResponse[]> => {
  return httpClient<StructureTypeResponse[]>(`/nodeTypeCategories/${categoryCode}/nodeTypes`, HttpMethod.Get);
};

export const createStructureType = (nodeType: StructureType): Promise<StructureTypeResponse> => {
  return httpClient<StructureTypeResponse>('/nodeTypes', HttpMethod.Post, nodeType);
};

export const getStructureTypeByCode = (code: string): Promise<StructureTypeResponse> => {
  return httpClient<StructureTypeResponse>(`/nodeTypes/${code}`, HttpMethod.Get);
};

export const getStructureTypeByCodeForUpdate = (code: string): Promise<StructureTypeResponse> => {
  return httpClient<StructureTypeResponse>(`/nodeTypes/${code}/updateType`, HttpMethod.Get);
};

export const updateStructureType = (code: string, nodeType: StructureType): Promise<StructureTypeResponse> => {
  return httpClient<StructureTypeResponse>(`/nodeTypes/${code}`, HttpMethod.Put, nodeType);
};
